










































































































import { Component, Mixins } from 'vue-property-decorator'
import { BasicMixin } from "@/mixins/AdminMixin"
import {ActivityCategoryInterface, ActivitySubCategoryInterface} from "@/models/Activity";
import CardHeader from "@/components/CardHeader.vue";
import {mapState} from "vuex";
@Component({
    components:{
        CardHeader
    },
    computed:{
        ...mapState({
            ActivityCategory:(state: any) => state.activity.ActivityCategory,
            ActivitySubCategory:(state: any) => state.activity.ActivitySubCategory
        })
    }
})
export default  class ActivitySubCategory extends Mixins(BasicMixin){
    public headers = [
        {
            text: 'Titulo',
            align: 'left',
            sortable: true,
            value: 'title',
        },
        {
            text: 'Categoria',
            align: 'left',
            sortable: true,
            value: 'category',
        },
        {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'createdAt',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public actSubCategory: ActivitySubCategoryInterface = {
        title: '',
        category: {
            title:'',
            id:''
        },
    };
    public categoryId: ActivityCategoryInterface;


    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.actSubCategory, collection: 'ActivitySubCategory'});
            this.text = 'Se ha editado la sub-categoria';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.addId()
            this.$store.dispatch('createSubCategory', this.actSubCategory);
            this.text = 'Se ha creado la sub-categoria';
            this.dialog = false;
            this.snackbar = true;
        }

    }

    openModal(edit: boolean, item: ActivitySubCategory | any) {
        this.edit = edit;
        this.dialog = true;
        if (edit) {
            this.idModel = item.id
            this.actSubCategory = {
                title: item.title,
                category: item.category

            }
        } else {
            this.actSubCategory = {
                title: '',
                category: {
                    title:'',
                    id:''
                },
            }
        }
    }
    deleteItem(item: any){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'ActivitySubCategory'})
    }
    chang(e: any){

        this.categoryId = e
    }
    addId(){
        this.actSubCategory.category= {
            title:'',
                id:''

        };
        this.actSubCategory.category.id = this.categoryId.id;
        this.actSubCategory.category.title = this.categoryId.title;
        this.actSubCategory.category.createdAt = this.categoryId.createdAt;

    }

    closeModal(){
        this.actSubCategory = {
            title: '',
            category: {
                title: '',
                id: ''
            },
        }
    }
}
